import type { Component } from 'vue';

import Avatar from './avatar.vue';
import Back from './back.vue';
import Image from './image.vue';
import ImageMask from './ImageMask.vue';

export default new Map<string, Component>([
  ['Avatar', Avatar],
  ['Back', Back],
  ['Image', Image],
  ['ImageMask', ImageMask],
]);